import { Link } from "react-router-dom";
import CareerApplicationForm from "./careerAppForm";
import { useState } from "react";
import { formatDateWithTime } from "./recentJobCard";
import { Calendar, Award, Code2, GraduationCap, ArrowRight } from "lucide-react";
import Button from "../common/Button";

const CareerCard = ({
    title,
    deadline,
    experience,
    skills,
    slug,
    id,
    qualification,
}: any) => {
    //Modal
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
    };
    const handleShow = () => setShow(true);

    return (
        <div key={id} className="cht-h-full">
            <div className="cht-bg-white cht-rounded-[20px] cht-border cht-border-slate-200/80 cht-shadow-soft hover:cht-shadow-float hover:cht-border-[#3e57da]/40 cht-transition-all cht-duration-300 cht-p-6 sm:cht-p-7 cht-flex cht-flex-col cht-justify-between cht-h-full !cht-font-body">
                <div>
                    <h5 className="cht-text-lg sm:cht-text-xl cht-font-bold !cht-font-heading cht-text-[#1e293b] cht-mb-4 cht-line-clamp-2">
                        {title}
                    </h5>

                    <div className="cht-space-y-2.5 cht-mb-6">
                        <div className="cht-flex cht-items-start cht-gap-2.5 cht-text-sm cht-text-slate-600">
                            <Award className="cht-w-4 cht-h-4 cht-text-[#3e57da] cht-shrink-0 cht-mt-0.5" />
                            <span>
                                <strong className="cht-font-semibold cht-text-slate-700">Experience:</strong>{" "}
                                {experience}
                            </span>
                        </div>

                        {skills && (
                            <div className="cht-flex cht-items-start cht-gap-2.5 cht-text-sm cht-text-slate-600">
                                <Code2 className="cht-w-4 cht-h-4 cht-text-[#3e57da] cht-shrink-0 cht-mt-0.5" />
                                <span className="cht-line-clamp-2">
                                    <strong className="cht-font-semibold cht-text-slate-700">Skills:</strong>{" "}
                                    {skills}
                                </span>
                            </div>
                        )}

                        {deadline && (
                            <div className="cht-flex cht-items-start cht-gap-2.5 cht-text-sm cht-text-slate-600">
                                <Calendar className="cht-w-4 cht-h-4 cht-text-[#3e57da] cht-shrink-0 cht-mt-0.5" />
                                <span>
                                    <strong className="cht-font-semibold cht-text-slate-700">Deadline:</strong>{" "}
                                    {formatDateWithTime(deadline)}
                                </span>
                            </div>
                        )}

                        {qualification && (
                            <div className="cht-flex cht-items-start cht-gap-2.5 cht-text-sm cht-text-slate-600">
                                <GraduationCap className="cht-w-4 cht-h-4 cht-text-[#3e57da] cht-shrink-0 cht-mt-0.5" />
                                <span className="cht-line-clamp-1">
                                    <strong className="cht-font-semibold cht-text-slate-700">Qualification:</strong>{" "}
                                    {qualification}
                                </span>
                            </div>
                        )}
                    </div>
                </div>

                <div className="cht-flex cht-items-center cht-gap-3 cht-pt-4 cht-border-t cht-border-slate-100">
                    <Button
                        variant="primary"
                        size="md"
                        className="cht-flex-1"
                        onClick={handleShow}
                    >
                        Apply Now
                    </Button>

                    <Button
                        to={slug}
                        variant="subtle"
                        size="md"
                        rightIcon={<ArrowRight className="cht-w-3.5 cht-h-3.5" />}
                    >
                        Details
                    </Button>
                </div>
            </div>

            <CareerApplicationForm
                show={show}
                onClose={handleClose}
                role={title}
                role_id={id}
            />
        </div>
    );
};

export default CareerCard;
